const loginDictPT = {
  to: "na",
  signInWith: "Entre com as credenciais da sua conta ativada",
  forgotPassword: "Esqueceu sua senha?",
  sendEmail: "Enviar Email",
  // toast
  pleaseFillOut: "Por favor preencha os campos de usuário e senha.",
  pleaseReverify: "Por favor verifique novamente o ReCaptcha.",
  incorrectCredentials: "Credenciais incorretas.",
  tooManyLoginAttempts: "Muitas tentativas de acesso sem sucesso. Tente novamente em alguns minutos ou use \"Esqueceu sua senha?\".",
  pleaseCheckEmail: "Por favor verifique seu endereço de email para ativar sua conta.",
  pleaseCheckEmailTemp:
    "Verifique o link enviado ao seu e-mail para trocar sua senha. Ele tem duração de 60 minutos.",
  userNotFound: "Usuário não encontrado.",
  thisEmailDoesnt: "Este email não corresponde a este usuário.",
  error: "Erro",
  success: "Sucesso",
  notRegisteredYetRegisterAs: "Ainda não registrado? Registre-se como",
  welcomeBack: "Seja bem-vindo",
  emailOrUsername: "E-mail ou nome de usuário",
  enterRegisteredEmail: "Digite o e-mail cadastrado",
  enterYourPassword: "Informe sua senha de acesso",
  rememberMe: "Manter conectado",
  accessMyAccount: "Acessar minha conta",
  notPartOfNetwork: "Ainda não faz parte da rede?",
  createAccountNow: "Crie sua conta agora e comece a gerar valor.",
  loginAndKeepGrowing: "Entre e continue crescendo com a Extraconomy",
  accessYourAccountDescription:
    "Acesse sua conta e aproveite oportunidades para expandir sua rede, seus ganhos e seu impacto.",
  // Reset Password
  resetPassword: "Redefinir Senha",
  enterNewPassword: "Digite sua nova senha",
  newPassword: "Nova Senha",
  confirmPassword: "Confirmar Senha",
  confirmNewPassword: "Confirme sua nova senha",
  changePassword: "Alterar Senha",
  backToLogin: "Voltar ao login",
  invalidLink: "Link inválido ou expirado. Redirecionando para login...",
  passwordsDoNotMatch: "As senhas não coincidem.",
  passwordTooShort: "A senha deve ter pelo menos 8 caracteres.",
  passwordChangedSuccessfully: "Senha alterada com sucesso! Redirecionando para login...",
  errorChangingPassword: "Erro ao alterar senha. Tente novamente ou solicite um novo link.",
  resetYourPassword: "Redefina sua senha",
  createNewPasswordDescription: "Crie uma nova senha para recuperar o acesso à sua conta.",
  passwordAlreadyChanged: "Esta solicitação de alteração de senha já foi utilizada.",
  enterTheEmailAddressAssociatedYourAccount: "Digite o e-mail cadastrado na sua conta",
  weWillSendYouALinkToSecurelyCreateANewPassword:
    "Enviaremos um link para você criar uma nova senha com segurança.",
  active: "Ativo",
  memberCount: "Número de membros",
  subnets: "Sub-redes",
  subnet: "Sub-rede",
  loginSEODescription:
    "Faça login na Extraconomy para acessar sua conta, expandir sua rede e aproveitar oportunidades exclusivas de negócios.",
  // Entrada vinda da Federnet (FedernetHandoff.js)
  federnetHandoffLoading: "Levando você para a Extraconomy…",
  federnetHandoffErrorTitle: "Não foi possível entrar",
  federnetHandoffErrorText:
    "O link vindo da Federnet expirou ou já foi usado. Entre com o seu usuário e a sua senha.",
  federnetHandoffGoToLogin: "Ir para o login",
};

export default loginDictPT;
